import React, { useEffect, useState, memo } from "react";
import PropTypes from "prop-types";

const JsonEditor = ({ initialValue = {}, onChange }) => {
  const [jsonData, setJsonData] = useState('');

  // Function to handle changes in the text area
  const handleInputChange = (event) => {
    const data = event.target.value;
    setJsonData(data);
    if (onChange) {
      onChange(data);
    }
  };

  useEffect(() => {
    try {
      const formatted = JSON.stringify(initialValue, null, 2);
      setJsonData(formatted);
    } catch (error) {
      setJsonData(String(initialValue));
    }
  }, [initialValue]);

  return (
    <textarea
      value={jsonData}
      onChange={handleInputChange}
      rows={25}
      spellCheck={false}
      style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', width: "100%" }}
    />
  );
};

JsonEditor.propTypes = {
  initialValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
}

export default memo(JsonEditor);